<div class="modal-header" *transloco="let t">
  <h5 class="modal-title" [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'delete'">{{ t('childHistory/deleteTitle') }}</ng-container>
    <ng-container *ngSwitchDefault>{{ t('childHistory/replaceTitle') }}</ng-container>
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" *transloco="let t">
  <p [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'delete'">{{ t('childHistory/deleteConfirm') }}</ng-container>
    <ng-container *ngSwitchDefault>{{ t('childHistory/replaceConfirm') }}</ng-container>
  </p>

  <div class="change-summary mt-3" *ngIf="changeSummary.length">
    <div class="summary-title">{{ t('childHistory/changeSummary') }}</div>
    <div class="summary-row" *ngFor="let item of changeSummary">
      <div class="summary-label">{{ item.label }}</div>
      <div class="summary-value" [title]="item.value">{{ item.value }}</div>
    </div>
  </div>
</div>

<div class="modal-footer" *transloco="let t">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.dismiss()">{{ t('shared/NO') }}</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">{{ t('shared/YES') }}</button>
</div>
